import { render, staticRenderFns } from "./EditDocumentLink.vue?vue&type=template&id=0b0c72b1"
import script from "./EditDocumentLink.vue?vue&type=script&lang=js"
export * from "./EditDocumentLink.vue?vue&type=script&lang=js"
import style0 from "./EditDocumentLink.vue?vue&type=style&index=0&id=0b0c72b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports